import { memo } from 'react'
import { ErrorMessage, Field, FieldProps as FormikFieldProps } from 'formik'
import { useIntl } from 'react-intl'
import has from 'lodash/has'

import { FieldProps } from '../types'
import { emailFieldMessages } from './messages'
import {
  CommonStyledInput,
  StyledInputError,
  StyledInputLabelWrapper,
  StyledLabel,
} from 'components/Input/styles'

function EmailField({ showLabel = false, ...props }: FieldProps) {
  const { formatMessage } = useIntl()
  const { name, placeholder } = props

  return (
    <Field name={name}>
      {({ field, form: { errors, touched } }: FormikFieldProps) => (
        <>
          {showLabel && field?.value && (
            <StyledInputLabelWrapper>
              <StyledLabel htmlFor={name}>{placeholder}</StyledLabel>
            </StyledInputLabelWrapper>
          )}
          <CommonStyledInput
            type="email"
            id={props.name}
            placeholder={
              placeholder ?? `${formatMessage(emailFieldMessages.placeholder)}`
            }
            invalid={has(errors, name) && has(touched, name)}
            {...field}
            {...props}
          />
          <StyledInputError>
            <ErrorMessage name={props.name} />
          </StyledInputError>
        </>
      )}
    </Field>
  )
}

export default memo(EmailField)
